import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';
import {GlobalFunction} from '../core/global_function';


@Injectable()
export class UserService extends ServiceGlobal {
    api_find_all: any = 'users';

    email:string;
    password:string;
    gender:number;
    status:number;
    avartar:string;
    access_token:string;
    auth_key:string;
    app_type:number;
    birthday:string;
    display_name:string;
    phone:string;
    firstname: string;
    lastname: string;
    plan_id:Number;
    address:string;
    role:string;
    confirm_password:string;
    user_role_mul:any;
    fk_table_user_role_mul:any;

    is_delete:number;

    fk_table_role:any;

    assign_id:number;
    fk_table_assign_id:any;

    fk_table_notification: any = [
        { id: 1, text: 'Có' },
        { id: 0, text: 'Không' },
    ];

    notification:Number;
    user_admin_table_column_mul:any;
    user_notification_settings_mul:any;
    fk_table_user_notification_settings_mul:any;

    notification_setting_group_user_mul:any;
    fk_table_notification_setting_group_user_mul:any;
    dbname() {
        return 'cyber_northstar';
    }
    loading: any = false;
    tableName() { return 'user'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "notification_setting_group_user_mul": "notification_setting_group_user_mul",
            "user_admin_table_column_mul": "user_admin_table_column_mul",
            "user_chat_room_mul": "user_chat_room_mul",
            "user_notification_settings_mul": "user_notification_settings_mul",
            "user_role_mul": "Role",
            "id": "ID",
            "email": "Email",
            "password": "Password",
            "gender": "Gender",
            "status": "Status",
            "avartar": "Avatar",
            "access_token": "Access Token",
            "auth_key": "Auth Key",
            "app_type": "App Type",
            "birthday": "Date of birth",
            "display_name": "Display name",
            "phone": "Phone number",
            "address": "Address",
            "role": "Role",
            "is_delete": "Is Delete",
            "assign_id": "Assign",
            "notification": "Notification",
            "fk_table_assign_id": "fk_table_assign_id",
            "fk_table_role": "fk_table_role",
            "confirm_password": "Confirm password",
            "firstname": "Firstname",
            "lastname": "Lastname",
            "plan_id": "Plan Id",
            "fk_table_user_role_mul": "fk_table_user_role_mul",
            "fk_table_user_notification_settings_mul": "fk_table_user_notification_settings_mul",
            "fk_table_notification_setting_group_user_mul": "fk_table_notification_setting_group_user_mul",
            "list_notification_settings": "list_notification_settings"
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "id": {
                "type": "int",
                "auto_increment": true,
                "primary_key": true,
                "size": 11
            },
            "email": {
                "type": "varchar",
                "require": {
                    "empty": true,
                    "email": true,
                    "size": 255
                },
                "size": 255
            },
            "password": {
                "type": "varchar",
                "require": {
                    "empty": true,
                    "password": true,
                    "regex": {
                        "value": "(?=.*[a-zA-Z])(?=.*[0-9])",
                        "message": "Must be strong password"
                    },
                    "size": 255,
                    "min": 6
                },
                "size": 255
            },
            "confirm_password": {
                "type": "varchar",
                "require": {
                    "empty": {
                        "on": "change_password"
                    },
                    "password": true,
                    "size": 100,
                    "same": {
                        "attribute": "password"
                    }
                },
                "size": 100
            },
            "gender": {
                "default": "0",
                "type": "int",
                "size": 1
            },
            "status": {
                "default": "1",
                "type": "tinyint",
                "size": 1
            },
            "avartar": {
                "type": "varchar",
                "require": {
                    "size": 255
                },
                "size": 255
            },
            "access_token": {
                "type": "varchar",
                "require": {
                    "size": 255
                },
                "size": 255
            },
            "auth_key": {
                "type": "varchar",
                "require": {
                    "size": 255
                },
                "size": 255
            },
            "app_type": {
                "default": "0",
                "type": "tinyint",
                "size": 1
            },
            "birthday": {
                "type": "varchar",
                "require": {
                    "size": 20
                },
                "size": 20
            },
            "display_name": {
                "type": "varchar",
                "require": {
                    "empty": true,
                    "size": 500
                },
                "size": 500
            },
            "phone": {
                "type": "varchar",
                "require": {
                    "empty": true,
                    "phone": true,
                    "size": 20
                },
                "size": 20
            },
            "address": {
                "default": "",
                "type": "varchar",
                "require": {
                    "size": 255
                },
                "size": 255
            },
            "role": {
                "type": "varchar",
                "size": 255,
                "fk": {
                    "table": "role",
                    "ref_id": "id"
                },
                "require": {
                    "size": 255
                }
            },
            "is_delete": {
                "default": "0",
                "type": "tinyint",
                "size": 1
            },
            "fk_table_role": {
                "type": "any"
            },
            "user_role_mul": {
                "type": "array",
                "size": 11,
                "require": {
                    "empty": {
                        "on": [
                            "create",
                            "admin_update_staff"
                        ]
                    }
                },
                "update_attr": "role",
                "mul_id": "user_id",
                "mul_id_fk": "role_id",
                "fk": {
                    "table": "role",
                    "ref_id": "id"
                }
            },
            "fk_table_user_role_mul": {
                "type": "any"
            },
            "assign_id": {
                "type": "int",
                "size": 11,
                "fk": {
                    "table": "user",
                    "ref_id": "id"
                }
            },
            "fk_table_assign_id": {
                "type": "any"
            },
            "user_notification_settings_mul": {
                "type": "array",
                "size": 11,
                "update_attr": "notification_settings_id",
                "mul_id": "user_id",
                "mul_id_fk": "notification_settings_id",
                "fk": {
                    "table": "notification_settings",
                    "ref_id": "id",
                    "select": "group_concat(role_id) as role_id",
                    "join": [
                        [
                            "notification_settings_role_mul",
                            "INNER"
                        ]
                    ]
                }
            },
            "fk_table_user_notification_settings_mul": {
                "type": "any"
            },
            "notification": {
                "default": "1",
                "type": "tinyint",
                "size": 1
            },
            "user_admin_table_column_mul": {
                "type": "array",
                "size": 11,
                "mul_id": "user_id",
                "mul_id_fk": "admin_table_column_id",
                "fk": {
                    "table": "admin_table_column",
                    "ref_id": "id"
                }
            },
            "notification_setting_group_user_mul": {
                "type": "array",
                "size": 11,
                "mul_id": "user_id",
                "mul_id_fk": "notification_setting_group_id",
                "fk": {
                    "table": "notification_setting_group",
                    "ref_id": "id"
                }
            },
            "fk_table_notification_setting_group_user_mul": {
                "type": "any"
            }
        });
    }

    getInformation() {
        if(!GlobalFunction['userInformation'] && typeof(GlobalFunction['userInformation']) != 'object') {
            var that = this;
            return this._db.get(API.INFORMATION).then(rs => {
                GlobalFunction['userInformation'] = rs;
                if(rs.code == 200) {
                    that.setAttributes(rs.attributes);
                    that._old_attributes = rs.attributes;
                }
                return rs;
            })
        } else {
            this.setAttributes(GlobalFunction['userInformation'].attributes);
            this._old_attributes = GlobalFunction['userInformation'].attributes;
            return Promise.resolve(GlobalFunction['userInformation']);
        }
    }

    isFirstLogin() {
        var that = this;
        return that.created_time && (that.created_time === that.modified_time);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/user.service.ts